// accordian dropdown  - ----------------------------------
// Collapse accordion every time dropdown is shown
$('.dropdown-accordion').on('show.bs.dropdown', function (event) {
  var accordion = $(this).find($(this).data('accordion'));
  accordion.find('.panel-collapse.in').collapse('hide');
});

// Prevent dropdown to be closed when we click on an accordion link
$('.dropdown-accordion').on('click', 'a[data-toggle="collapse"]', function (event) {
  event.preventDefault();
  event.stopPropagation();
  $($(this).data('parent')).find('.panel-collapse.in').collapse('hide');
  $($(this).attr('href')).collapse('show');
})


// searchable dropdown -----------------------------------------



  $(document).ready(function(){
    // Clear active tab data when on the homepage
    if (window.location.pathname === '/' || window.location.pathname === '/index.php') {
      localStorage.removeItem('activeTab');
    }

    // Check if the current page is a collection product page
    if (window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/collections/all')) {
      $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
        localStorage.setItem('activeTab', $(e.target).attr('href'));
      });

      var activeTab = localStorage.getItem('activeTab');
      if (activeTab) {
        // Show the saved tab
        $('#myTab a[href="' + activeTab + '"]').tab('show');
      } else {
        // If no tab is saved, activate the first tab by default
        $('#myTab a:first').tab('show');
      }
    }
  });




function myFunction() {
  document.getElementById("myDropdown").classList.toggle("show");
}

function filterFunction() {
  const input = document.getElementById("searchmyInput");
  const filter = input.value.toUpperCase();
  const div = document.getElementById("myDropdown");
  const a = div.getElementsByTagName("a");
  for (let i = 0; i < a.length; i++) {
    txtValue = a[i].textContent || a[i].innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      a[i].style.display = "";
    } else {
      a[i].style.display = "none";
    }
  }
}

// second serachable dropdown

function myFunctiondropdown() {
  document.getElementById("myDropdownsecond").classList.toggle("show");
}

function filterFunctionsecond() {
  const input = document.getElementById("searchmyInputsecond");
  const filter = input.value.toUpperCase();
  const div = document.getElementById("myDropdownsecond");
  const a = div.getElementsByTagName("a");
  for (let i = 0; i < a.length; i++) {
    txtValue = a[i].textContent || a[i].innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      a[i].style.display = "";
    } else {
      a[i].style.display = "none";
    }
  }
}

// product center big slider page -------------------------------
 // Slick Slider
 jQuery(".slick-slider").slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  autoplay: false,
  variableWidth: true,
  centerMode: true,
  centerPadding: "0",
  effect: 'cube',
   cssEase: 'linear',
  behavior: 'smooth',
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 5,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow:3,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
      }
    }
  ]
});

// Slick Scroll
jQuery(function () {
  const slider = jQuery(".slick-slider");
  slider;

  slider.on("wheel", function (e) {
      e.preventDefault();

      if (e.originalEvent.deltaY < 0) {
          jQuery(this).slick("slickNext");
      } else {
          jQuery(this).slick("slickPrev");
      }
  });
});

// mouse wheel product slider -----------------------------------------

$(document).ready(function () {

  /* Small card slider */
  $('.eshop-like-product-Div .slider').slick({
    arrows: false,
    dots: false,
    infinite: true,
    initialSlide: 0,
    slidesToScroll: 1,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  const slider = $(".slider");
  var scrollCount = null;
  var scroll = null;

  slider.on('wheel', (function (e) {
    e.preventDefault();

    clearTimeout(scroll);
    scroll = setTimeout(function () { scrollCount = 0; }, 200);
    if (scrollCount) return 0;
    scrollCount = 1;

    if (e.originalEvent.deltaY < 0) {
      $(this).slick('slickNext');
    } else {
      $(this).slick('slickPrev');
    }
  }));
});




// product slider - --------------------------------------//

$(function () {
  var galleryThumbs = new Swiper(".gallery-thumbs", {
    centeredSlidesBounds: true,
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    breakpoints: {
      480: {
        direction: "vertical",
        slidesPerView: 4
      },
      992: {
        direction: "vertical",
        slidesPerView: 4
      }
    }
  });
  var galleryTop = new Swiper(".gallery-top", {
    direction: "horizontal",
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    a11y: {
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
    },
    keyboard: {
      enabled: true,
    },
    thumbs: {
      swiper: galleryThumbs
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    mousewheel: {
      invert: false,
    },
  });
  galleryTop.on("slideChangeTransitionStart", function () {
    galleryThumbs.slideTo(galleryTop.activeIndex);
  });
  galleryThumbs.on("transitionStart", function () {
    galleryTop.slideTo(galleryThumbs.activeIndex);
  });
});

// psidebar header page -------------------------------

function openNav() {
  document.getElementById("mySidenav").style.width = "250px";
  //document.getElementById("header").style.marginLeft = "250px";
}

function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
  //document.getElementById("header").style.marginLeft= "0";
};

// 

 $('.tabgroup > div').hide();
  $('.tabgroup > div:first-of-type').show();
  $('.tabs-collaction-gallery a').click(function(e){
    e.preventDefault();
      var $this = $(this),
          tabgroup = '#'+$this.parents('.tabs-collaction-gallery').data('tabgroup'),
          others = $this.closest('li').siblings().children('a'),
          target = $this.attr('href');
      others.removeClass('active');
      $this.addClass('active');
      $(tabgroup).children('div').hide();
      $(target).show();

  })